<template>
  <CCard>
    <CCardHeader class="p-2 font-weight-bold" style="line-height: 2">
      몰리어(mollier) 다이어그램 연산
      <div class="pull-right">
        <div class="btn btn-sm bg-color-orange text-white mr-1">부족</div>
        <div class="btn btn-sm bg-color-green-dark text-white mr-1">적절</div>
        <div class="btn btn-sm bg-color-red text-white">과다</div>
      </div>
    </CCardHeader>
    <CCardBody class="p-2" v-if="emptyFlag"> 데이터 없음 </CCardBody>
    <CCardBody class="p-2" :class="emptyFlag ? 'd-none' : ''">
      <div class="row-sensor">
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 125px">측정온도(T)</div>
          <div class="sensor-val" style="min-width: 70px">
            {{ sensor.dryBulbTemp }} ℃
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 125px">상대습도(RH)</div>
          <div class="sensor-val" style="min-width: 70px">
            {{ sensor.relativeHumidity }} %
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 125px">절대습도(AH)</div>
          <div class="sensor-val" style="min-width: 70px">
            {{ sensor.absoluteHumidity }}
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 125px">
            이슬점온도(DEW)
          </div>
          <div class="sensor-val" style="min-width: 70px">
            {{ sensor.dewPointTemp }}
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 125px">수분부족량</div>
          <div
            class="sensor-val"
            :class="sensor.hdColor"
            style="min-width: 70px"
          >
            {{ sensor.hd }}
          </div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 125px">
            수증기압 포차(VPD)
          </div>
          <div
            class="sensor-val"
            :class="sensor.vpdColor"
            style="min-width: 70px"
          >
            {{ sensor.vpd }}
          </div>
        </div>
      </div>

      <div style="width: 90%; margin: 10px auto 10px auto">
        <VueSlideBar
          v-if="!emptyFlag"
          v-model="slider.value"
          :data="slider.list"
          :tooltipStyles="{
            backgroundColor: 'white',
            borderColor: '#9e9e9e',
            color: 'black',
          }"
        />
      </div>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 120 550 410">
        <title>mollier</title>
        <g>
          <line class="cls-1" x1="116.17" y1="477.78" x2="116.17" y2="149.21" />
          <line class="cls-1" x1="198.19" y1="374.92" x2="198.19" y2="149.21" />
          <line class="cls-1" x1="279.13" y1="315.27" x2="279.13" y2="149.21" />
          <line class="cls-1" x1="360.88" y1="270.28" x2="360.88" y2="149.21" />
          <line class="cls-1" x1="441.28" y1="232.24" x2="441.28" y2="149.21" />
          <line class="cls-1" x1="198.19" y1="477.78" x2="198.19" y2="413.82" />
          <line class="cls-1" x1="279.13" y1="477.78" x2="279.13" y2="381.84" />
          <line class="cls-1" x1="360.88" y1="477.09" x2="360.88" y2="350.13" />
          <line class="cls-1" x1="441.28" y1="477.09" x2="441.28" y2="318.8" />
          <line class="cls-1" x1="33.36" y1="198.04" x2="522.32" y2="198.04" />
          <line class="cls-1" x1="33.36" y1="244.77" x2="413.16" y2="244.77" />
          <line class="cls-1" x1="509.49" y1="292.21" x2="522.42" y2="292.21" />
          <line class="cls-1" x1="33.46" y1="292.21" x2="317.09" y2="292.21" />
          <line class="cls-1" x1="392.45" y1="338.23" x2="522.15" y2="338.23" />
          <line class="cls-1" x1="32.19" y1="338.23" x2="246.48" y2="338.23" />
          <line class="cls-1" x1="270.83" y1="384.96" x2="522.15" y2="384.96" />
          <line class="cls-1" x1="32.19" y1="384.96" x2="188.9" y2="384.96" />
          <line class="cls-1" x1="152.29" y1="431.43" x2="522.15" y2="431.43" />
          <line class="cls-1" x1="32.19" y1="431.43" x2="147.48" y2="431.43" />
        </g>
        <g ref="mollierGraph">
          <rect
            class="cls-2"
            x="33.36"
            y="149.21"
            width="488.96"
            height="328.57"
          />
          <line class="cls-2" x1="48.41" y1="477.78" x2="48.41" y2="149.21" />
          <line class="cls-2" x1="65.98" y1="477.78" x2="65.98" y2="149.21" />
          <line class="cls-2" x1="82.44" y1="477.78" x2="82.44" y2="149.21" />
          <line class="cls-2" x1="99.44" y1="477.78" x2="99.44" y2="149.21" />
          <line class="cls-2" x1="132.9" y1="477.78" x2="132.9" y2="149.21" />
          <line class="cls-2" x1="148.62" y1="430.75" x2="148.62" y2="149.21" />
          <line class="cls-2" x1="164.35" y1="410.81" x2="164.35" y2="149.21" />
          <line class="cls-2" x1="181.92" y1="391.35" x2="181.92" y2="149.21" />
          <line class="cls-2" x1="213.84" y1="362.39" x2="213.84" y2="149.21" />
          <line class="cls-2" x1="230.56" y1="348.55" x2="230.56" y2="149.21" />
          <line class="cls-2" x1="246.48" y1="337.75" x2="246.48" y2="149.21" />
          <line class="cls-2" x1="262.94" y1="326.08" x2="262.94" y2="149.21" />
          <line class="cls-2" x1="295.59" y1="305.76" x2="295.59" y2="149.21" />
          <line class="cls-2" x1="312.32" y1="295.82" x2="312.32" y2="149.21" />
          <line class="cls-2" x1="327.96" y1="287.17" x2="327.96" y2="149.21" />
          <line class="cls-2" x1="344.42" y1="278.49" x2="344.42" y2="149.21" />
          <line class="cls-2" x1="376.53" y1="262.46" x2="376.53" y2="149.21" />
          <line class="cls-2" x1="392.45" y1="254.6" x2="392.45" y2="149.21" />
          <line class="cls-2" x1="409.17" y1="246.84" x2="409.17" y2="149.21" />
          <line class="cls-2" x1="425.09" y1="240.05" x2="425.09" y2="149.21" />
          <line class="cls-2" x1="457.74" y1="226.65" x2="457.74" y2="149.21" />
          <line class="cls-2" x1="473.66" y1="220.6" x2="473.66" y2="149.21" />
          <line class="cls-2" x1="489.04" y1="214.61" x2="489.04" y2="149.21" />
          <line class="cls-2" x1="506.3" y1="207.63" x2="506.3" y2="149.21" />
          <line class="cls-2" x1="148.62" y1="478.63" x2="148.62" y2="433.43" />
          <line class="cls-2" x1="164.35" y1="477.78" x2="164.35" y2="426.79" />
          <line class="cls-2" x1="181.92" y1="478.63" x2="181.92" y2="419.88" />
          <line class="cls-2" x1="213.84" y1="477.78" x2="213.84" y2="406.91" />
          <line class="cls-2" x1="230.56" y1="477.78" x2="230.56" y2="400.42" />
          <line class="cls-2" x1="246.48" y1="477.78" x2="246.48" y2="394.81" />
          <line class="cls-2" x1="262.94" y1="477.78" x2="262.94" y2="388.32" />
          <line class="cls-2" x1="295.59" y1="477.78" x2="295.59" y2="375.58" />
          <line class="cls-2" x1="312.32" y1="477.09" x2="312.32" y2="368.87" />
          <line class="cls-2" x1="327.96" y1="477.09" x2="327.96" y2="362.39" />
          <line class="cls-2" x1="344.42" y1="477.09" x2="344.42" y2="356.15" />
          <line class="cls-2" x1="376.53" y1="477.09" x2="376.53" y2="343.37" />
          <line class="cls-2" x1="392.45" y1="477.78" x2="392.45" y2="337.75" />
          <line class="cls-2" x1="409.18" y1="477.09" x2="409.18" y2="331.26" />
          <line class="cls-2" x1="425.09" y1="477.09" x2="425.09" y2="325.1" />
          <line class="cls-2" x1="457.74" y1="477.09" x2="457.74" y2="312.39" />
          <line class="cls-2" x1="473.66" y1="477.09" x2="473.66" y2="305.76" />
          <line class="cls-2" x1="489.04" y1="477.09" x2="489.04" y2="299.27" />
          <line class="cls-2" x1="506.3" y1="477.09" x2="506.3" y2="293.45" />
          <line class="cls-2" x1="33.36" y1="159.22" x2="522.32" y2="159.22" />
          <line class="cls-2" x1="33.36" y1="169.24" x2="522.32" y2="169.24" />
          <line class="cls-2" x1="33.36" y1="178.42" x2="522.32" y2="178.42" />
          <line class="cls-2" x1="33.36" y1="188.93" x2="522.32" y2="188.93" />
          <line class="cls-2" x1="33.36" y1="217.19" x2="480.05" y2="217.19" />
          <line class="cls-2" x1="33.36" y1="225.36" x2="457.74" y2="225.36" />
          <line class="cls-2" x1="33.36" y1="234.96" x2="435.61" y2="234.96" />
          <line class="cls-2" x1="33.36" y1="255.8" x2="388.74" y2="255.8" />
          <line class="cls-2" x1="33.44" y1="264.26" x2="371.81" y2="264.26" />
          <line class="cls-2" x1="33.44" y1="273.71" x2="353.67" y2="273.71" />
          <line class="cls-2" x1="33.44" y1="281.96" x2="338.25" y2="281.96" />
          <line class="cls-2" x1="486.4" y1="301.21" x2="522.42" y2="301.21" />
          <line class="cls-2" x1="33.46" y1="301.21" x2="302.28" y2="301.21" />
          <line class="cls-2" x1="462.03" y1="310.71" x2="522.42" y2="310.71" />
          <line class="cls-2" x1="33.46" y1="310.71" x2="286.56" y2="310.71" />
          <line class="cls-2" x1="438.29" y1="319.96" x2="522.42" y2="319.96" />
          <line class="cls-2" x1="33.46" y1="319.96" x2="271.44" y2="319.96" />
          <line class="cls-2" x1="415.2" y1="328.96" x2="522.42" y2="328.96" />
          <line class="cls-2" x1="33.46" y1="328.96" x2="258.74" y2="328.96" />
          <line class="cls-2" x1="366.07" y1="347.55" x2="521.15" y2="347.55" />
          <line class="cls-2" x1="32.19" y1="347.55" x2="232.14" y2="347.55" />
          <line class="cls-2" x1="340.79" y1="357.96" x2="521.15" y2="357.96" />
          <line class="cls-2" x1="32.19" y1="357.96" x2="219.13" y2="357.96" />
          <line class="cls-2" x1="318.98" y1="366.46" x2="521.15" y2="366.46" />
          <line class="cls-2" x1="32.19" y1="366.46" x2="209.16" y2="366.46" />
          <line class="cls-2" x1="297.27" y1="374.92" x2="521.15" y2="374.92" />
          <line class="cls-2" x1="32.19" y1="374.92" x2="199.48" y2="374.92" />
          <line class="cls-2" x1="246.48" y1="394.81" x2="521.15" y2="394.81" />
          <line class="cls-2" x1="32.19" y1="394.81" x2="178.92" y2="394.81" />
          <line class="cls-2" x1="220.95" y1="404.32" x2="521.15" y2="404.32" />
          <line class="cls-2" x1="32.19" y1="404.32" x2="170.46" y2="404.32" />
          <line class="cls-2" x1="200.69" y1="412.32" x2="521.15" y2="412.32" />
          <line class="cls-2" x1="32.19" y1="412.32" x2="162.9" y2="412.32" />
          <line class="cls-2" x1="173.78" y1="422.87" x2="521.15" y2="422.87" />
          <line class="cls-2" x1="32.19" y1="422.87" x2="154.74" y2="422.87" />
          <line class="cls-2" x1="32.19" y1="440.98" x2="521.15" y2="440.98" />
          <line class="cls-2" x1="32.19" y1="450.54" x2="521.15" y2="450.54" />
          <line class="cls-2" x1="32.19" y1="460.09" x2="521.15" y2="460.09" />
          <line class="cls-2" x1="32.19" y1="469.65" x2="521.15" y2="469.65" />
          <line class="cls-2" x1="33.36" y1="207.16" x2="506.3" y2="207.16" />
          <line class="cls-2" x1="33.36" y1="477.78" x2="522.42" y2="287.17" />
        </g>
        <g>
          <line class="cls-3" x1="33.36" y1="443.28" x2="65.98" y2="478.65" />
          <line class="cls-3" x1="32.19" y1="404.32" x2="99.44" y2="477.78" />
          <path
            class="cls-4"
            d="M277.81,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M197.8,429.25"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M290,497"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M197.7,398.43"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M304.86,477.09"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M197.7,370.33"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M320.23,457.88"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M197.67,334.67"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M335.32,440.35"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M197.7,293.17"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M352.67,421.84"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M197.7,254.13"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M373,403.1"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M198.64,214.46"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M394.9,384.59"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M212.75,186"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M422.17,366.22"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M256.86,186"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M450,347.79"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M301.58,186"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M481.43,329.36"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M348.6,185.75"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M517.17,309.75"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M399.89,185.94"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M555.83,291"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M455.07,185.94"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M599.34,271"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M517.76,185.94"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M644.39,253.23"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M582.33,185.25"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M686.66,230.67"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-4"
            d="M643.17,185.25"
            transform="translate(-164.34 -36.04)"
          />
          <line class="cls-3" x1="33.36" y1="366.46" x2="121.23" y2="467.24" />
          <line class="cls-3" x1="33.46" y1="284.66" x2="150.91" y2="427.92" />
          <line class="cls-3" x1="33.73" y1="199.34" x2="183.82" y2="390.45" />
          <line class="cls-3" x1="33.46" y1="151.44" x2="201.51" y2="372.94" />
          <line class="cls-3" x1="63.43" y1="149.9" x2="221.12" y2="356.1" />
          <line class="cls-3" x1="98.01" y1="149.9" x2="240.34" y2="341.7" />
          <line class="cls-3" x1="130.59" y1="149.9" x2="261.94" y2="326.89" />
          <line class="cls-3" x1="163" y1="149.21" x2="282.52" y2="313.71" />
          <line class="cls-3" x1="194.21" y1="149.21" x2="304.39" y2="300.57" />
          <line class="cls-3" x1="227.01" y1="149.21" x2="326.44" y2="287.41" />
          <line class="cls-3" x1="256.71" y1="149.21" x2="350.32" y2="276.26" />
          <line class="cls-3" x1="290.73" y1="149.9" x2="371.81" y2="264.26" />
          <line class="cls-3" x1="323.21" y1="148.65" x2="395.85" y2="253" />
          <line class="cls-3" x1="353.26" y1="149.82" x2="419.65" y2="242.11" />
          <line class="cls-3" x1="385.04" y1="149.81" x2="443.86" y2="231.58" />
          <line class="cls-3" x1="416.75" y1="149.21" x2="468.77" y2="221.53" />
          <line class="cls-3" x1="451.13" y1="149.21" x2="492" y2="212.1" />
          <line class="cls-3" x1="480.05" y1="149.21" x2="518.89" y2="202.5" />
          <line class="cls-3" x1="513.47" y1="149.21" x2="522.32" y2="161.36" />
          <line class="cls-3" x1="33.56" y1="241.92" x2="166.37" y2="409.54" />
          <line class="cls-3" x1="33.46" y1="326.21" x2="136.28" y2="447.41" />
        </g>
        <g>
          <line class="cls-5" x1="33.46" y1="393.21" x2="33.95" y2="393.73" />
          <line class="cls-6" x1="34.92" y1="394.77" x2="112.5" y2="477.61" />
          <line class="cls-5" x1="112.98" y1="478.13" x2="113.47" y2="478.65" />
          <line class="cls-5" x1="33.36" y1="362.39" x2="33.85" y2="362.9" />
          <line class="cls-7" x1="34.81" y1="363.93" x2="124.72" y2="459.93" />
          <line class="cls-5" x1="125.2" y1="460.45" x2="125.68" y2="460.97" />
          <line class="cls-5" x1="33.36" y1="334.29" x2="33.86" y2="334.79" />
          <line class="cls-8" x1="34.87" y1="335.8" x2="139.51" y2="440.04" />
          <line class="cls-5" x1="140.02" y1="440.55" x2="140.52" y2="441.05" />
          <line class="cls-5" x1="33.33" y1="298.63" x2="33.83" y2="299.13" />
          <line class="cls-9" x1="34.83" y1="300.14" x2="154.89" y2="420.83" />
          <line class="cls-5" x1="155.39" y1="421.34" x2="155.89" y2="421.84" />
          <line class="cls-5" x1="33.36" y1="257.13" x2="33.85" y2="257.64" />
          <line class="cls-10" x1="34.81" y1="258.68" x2="170.02" y2="403.28" />
          <line class="cls-5" x1="170.5" y1="403.8" x2="170.98" y2="404.32" />
          <line class="cls-5" x1="33.36" y1="218.09" x2="33.84" y2="218.61" />
          <line class="cls-11" x1="34.8" y1="219.64" x2="187.37" y2="384.76" />
          <line class="cls-5" x1="187.85" y1="385.28" x2="188.33" y2="385.8" />
          <line class="cls-5" x1="34.3" y1="178.42" x2="34.78" y2="178.94" />
          <line class="cls-12" x1="35.74" y1="179.98" x2="207.65" y2="366.02" />
          <line class="cls-5" x1="208.13" y1="366.54" x2="208.61" y2="367.06" />
          <line class="cls-5" x1="48.41" y1="149.96" x2="48.89" y2="150.48" />
          <line class="cls-13" x1="49.85" y1="151.52" x2="229.61" y2="347.51" />
          <line class="cls-5" x1="230.09" y1="348.03" x2="230.56" y2="348.55" />
          <line class="cls-5" x1="92.52" y1="149.96" x2="93" y2="150.48" />
          <line class="cls-14" x1="93.96" y1="151.53" x2="256.87" y2="329.14" />
          <line class="cls-5" x1="257.35" y1="329.66" x2="257.83" y2="330.18" />
          <line class="cls-5" x1="137.24" y1="149.96" x2="137.71" y2="150.48" />
          <line class="cls-15" x1="138.68" y1="151.53" x2="284.67" y2="310.7" />
          <line class="cls-5" x1="285.15" y1="311.23" x2="285.63" y2="311.75" />
          <line class="cls-5" x1="184.26" y1="149.71" x2="184.74" y2="150.23" />
          <line
            class="cls-16"
            x1="185.71"
            y1="151.27"
            x2="316.13"
            y2="292.28"
          />
          <line class="cls-5" x1="316.61" y1="292.8" x2="317.09" y2="293.32" />
          <line class="cls-5" x1="235.55" y1="149.91" x2="236.04" y2="150.42" />
          <line
            class="cls-17"
            x1="237.02"
            y1="151.45"
            x2="351.85"
            y2="272.68"
          />
          <line class="cls-5" x1="352.34" y1="273.2" x2="352.83" y2="273.71" />
          <line class="cls-5" x1="290.73" y1="149.9" x2="291.22" y2="150.41" />
          <line
            class="cls-18"
            x1="292.21"
            y1="151.44"
            x2="390.51"
            y2="253.93"
          />
          <line class="cls-5" x1="391" y1="254.45" x2="391.49" y2="254.96" />
          <line class="cls-5" x1="353.42" y1="149.9" x2="353.91" y2="150.41" />
          <line
            class="cls-19"
            x1="354.88"
            y1="151.42"
            x2="434.02"
            y2="233.94"
          />
          <line class="cls-5" x1="434.51" y1="234.45" x2="435" y2="234.96" />
          <line class="cls-5" x1="417.99" y1="149.21" x2="418.47" y2="149.73" />
          <line
            class="cls-20"
            x1="419.44"
            y1="150.79"
            x2="479.09"
            y2="216.13"
          />
          <line class="cls-5" x1="479.57" y1="216.67" x2="480.05" y2="217.19" />
          <line class="cls-5" x1="478.83" y1="149.21" x2="479.32" y2="149.72" />
          <line class="cls-21" x1="480.31" y1="150.75" x2="521.34" y2="193.6" />
          <line class="cls-5" x1="521.83" y1="194.12" x2="522.32" y2="194.63" />
        </g>
        <g>
          <path
            class="cls-22"
            d="M205.91,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M264.5,185.25s-42,75.25-58.59,329.44"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M330,185.25S235.21,298.5,213.5,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M394.5,185.25S250,305,221.5,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M459.5,185.25S277,297.64,230,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M525.5,185.25S292,297.64,238.5,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M589.5,185.25S313,294.5,246,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M653.5,186.38S337.5,291.5,253,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M686.86,197S344.75,309.25,262,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M686.86,217S350.67,329.67,271,514.69"
            transform="translate(-164.34 -36.04)"
          />
          <path
            class="cls-23"
            d="M277.81,514.69S341,417,410.5,374c0,0,92-70.5,277-137.5"
            transform="translate(-164.34 -36.04)"
          />
        </g>
        <g>
          <rect class="cls-24" x="146.99" width="45.24" height="17.1" />
          <rect class="cls-24" x="563.75" width="45.24" height="17.1" />
          <text class="cls-25" transform="translate(500.3 134.63)">
            RH
            <tspan class="cls-26" x="14.51" y="0"></tspan>
            <tspan class="cls-27" x="17.33" y="0">%</tspan>
          </text>
          <text class="cls-28" transform="translate(257.96 506.25)">
            AH(
            <tspan class="cls-29" x="17.81" y="0">g/</tspan>
            <tspan x="26.73" y="0">m</tspan>
          </text>
          <text class="cls-30" transform="translate(293.6 503.25)">3</text>
          <text class="cls-28" transform="translate(297.5 506.25)">)</text>
          <text class="cls-28" transform="translate(9.02 336.59) rotate(-90)">
            T
            <tspan class="cls-31" x="6.12" y="0">em</tspan>
            <tspan x="20.58" y="0">p</tspan>
            <tspan class="cls-32" x="26.7" y="0"></tspan>
            <tspan x="29.47" y="0">(</tspan>
          </text>
          <text class="cls-30" transform="translate(6.02 303.77) rotate(-90)">
            o
          </text>
          <text class="cls-28" transform="translate(9.02 299.51) rotate(-90)">
            <tspan class="cls-33">C</tspan>
            <tspan x="7.26" y="0">)</tspan>
          </text>
          <text class="cls-34" transform="translate(94.66 141.96)">10</text>
          <text class="cls-34" transform="translate(15.61 153.29)">35</text>
          <text class="cls-34" transform="translate(16.61 200.96)">30</text>
          <text class="cls-34" transform="translate(15.61 248.63)">25</text>
          <text class="cls-34" transform="translate(15.95 295.63)">20</text>
          <text class="cls-34" transform="translate(15.95 341.29)">15</text>
          <text class="cls-34" transform="translate(15.95 388.29)">10</text>
          <text class="cls-34" transform="translate(19.95 434.96)">5</text>
          <text class="cls-34" transform="translate(18.95 480.74)">0</text>
          <text class="cls-34" transform="translate(160.99 141.96)">20</text>
          <text class="cls-34" transform="translate(225.66 141.96)">30</text>
          <text class="cls-34" transform="translate(289.99 141.96)">40</text>
          <text class="cls-34" transform="translate(355.33 141.96)">50</text>
          <text class="cls-34" transform="translate(419.99 141.96)">60</text>
          <text class="cls-34" transform="translate(484.33 141.96)">70</text>
          <text class="cls-34" transform="translate(528.66 163.96)">80</text>
          <text class="cls-34" transform="translate(528.66 183.63)">90</text>
          <text class="cls-34" transform="translate(528.66 203.96)">100</text>
          <text class="cls-34" transform="translate(531.51 292.96)">4</text>
          <text class="cls-34" transform="translate(531.51 337.74)">3</text>
          <text class="cls-34" transform="translate(531.51 385.74)">2</text>
          <text class="cls-34" transform="translate(531.51 432.41)">1</text>
          <text class="cls-34" transform="translate(531.51 479.74)">0</text>
          <text class="cls-34" transform="translate(516.84 492.74)">30</text>
          <text class="cls-34" transform="translate(435.84 492.74)">25</text>
          <text class="cls-34" transform="translate(355.51 492.74)">20</text>
          <text class="cls-34" transform="translate(272.18 492.74)">15</text>
          <text class="cls-34" transform="translate(192.84 492.74)">10</text>
          <text class="cls-34" transform="translate(113.18 492.74)">5</text>
          <text class="cls-34" transform="translate(29.84 492.74)">0</text>
          <text class="cls-28" transform="translate(548.4 391.32) rotate(-90)">
            <tspan class="cls-35">kP</tspan>
            <tspan x="12.14" y="0">a</tspan>
          </text>
          <text
            class="cls-36"
            transform="translate(493.03 215.84) rotate(51.68)"
          >
            105 kJ
          </text>
          <text
            class="cls-36"
            transform="translate(468.84 226.66) rotate(45.82)"
          >
            100 kJ
          </text>
          <text
            class="cls-36"
            transform="matrix(0.69, 0.72, -0.72, 0.69, 421.51, 247.63)"
          >
            90 kJ
          </text>
          <text
            class="cls-36"
            transform="translate(373.5 268.89) rotate(50.58)"
          >
            80 kJ
          </text>
          <text
            class="cls-36"
            transform="translate(327.96 292.21) rotate(51.78)"
          >
            70 kJ
          </text>
          <text
            class="cls-36"
            transform="matrix(0.58, 0.82, -0.82, 0.58, 284.81, 319.81)"
          >
            60 kJ
          </text>
          <text
            class="cls-36"
            transform="matrix(0.63, 0.78, -0.78, 0.63, 242.21, 346.54)"
          >
            h=50 kJ
          </text>
          <text
            class="cls-36"
            transform="matrix(0.68, 0.74, -0.74, 0.68, 203.06, 377.01)"
          >
            40 kJ
          </text>
          <text
            class="cls-36"
            transform="matrix(0.76, 0.65, -0.65, 0.76, 189.29, 390.1)"
          >
            10°C
          </text>
          <text
            class="cls-36"
            transform="translate(220.95 360.23) rotate(48.22)"
          >
            12°C
          </text>
          <text class="cls-36" transform="translate(232.7 351.7) rotate(50.29)">
            14°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.72, 0.7, -0.7, 0.72, 258.01, 333.06)"
          >
            16°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.76, 0.65, -0.65, 0.76, 286.55, 315.27)"
          >
            18°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.76, 0.65, -0.65, 0.76, 319, 298.25)"
          >
            20°C
          </text>
          <text
            class="cls-36"
            transform="translate(354.91 278.4) rotate(46.68)"
          >
            22°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.76, 0.65, -0.65, 0.76, 394.21, 260.29)"
          >
            24°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.76, 0.65, -0.65, 0.76, 434.84, 239.46)"
          >
            26°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.76, 0.65, -0.65, 0.76, 481.46, 221.52)"
          >
            28°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.76, 0.65, -0.65, 0.76, 171.31, 408.09)"
          >
            8°C
          </text>
          <text
            class="cls-36"
            transform="matrix(0.68, 0.73, -0.73, 0.68, 164.99, 412.38)"
          >
            30 kJ
          </text>
          <polygon
            class="cls-37"
            points="103.1 143.96 100.12 148.91 97.22 144.08 103.1 143.96"
          />
          <polygon
            class="cls-37"
            points="168.6 143.96 165.62 148.91 162.72 144.08 168.6 143.96"
          />
          <polygon
            class="cls-37"
            points="233.5 143.96 230.53 148.91 227.63 144.08 233.5 143.96"
          />
          <polygon
            class="cls-37"
            points="298.52 143.96 295.55 148.91 292.65 144.08 298.52 143.96"
          />
          <polygon
            class="cls-37"
            points="364.1 143.96 361.12 148.91 358.23 144.08 364.1 143.96"
          />
          <polygon
            class="cls-37"
            points="428.03 143.96 425.06 148.91 422.16 144.08 428.03 143.96"
          />
          <polygon
            class="cls-37"
            points="492.23 143.96 489.26 148.91 486.36 144.08 492.23 143.96"
          />
          <polygon
            class="cls-37"
            points="438.35 483.03 441.32 478.08 444.22 482.91 438.35 483.03"
          />
          <polygon
            class="cls-37"
            points="357.45 483.03 360.42 478.08 363.32 482.91 357.45 483.03"
          />
          <polygon
            class="cls-37"
            points="519.22 483.03 522.19 478.08 525.09 482.91 519.22 483.03"
          />
          <polygon
            class="cls-37"
            points="527.52 481.02 522.57 478.05 527.4 475.15 527.52 481.02"
          />
          <polygon
            class="cls-37"
            points="527.52 434.36 522.57 431.39 527.4 428.49 527.52 434.36"
          />
          <polygon
            class="cls-37"
            points="527.52 387.68 522.57 384.7 527.4 381.81 527.52 387.68"
          />
          <polygon
            class="cls-37"
            points="527.52 341.16 522.57 338.19 527.4 335.29 527.52 341.16"
          />
          <polygon
            class="cls-37"
            points="527.52 295.15 522.57 292.18 527.4 289.27 527.52 295.15"
          />
          <polygon
            class="cls-37"
            points="275.52 483.03 278.49 478.08 281.39 482.91 275.52 483.03"
          />
          <polygon
            class="cls-37"
            points="194.95 483.03 197.92 478.08 200.82 482.91 194.95 483.03"
          />
          <polygon
            class="cls-37"
            points="113.02 483.03 115.99 478.08 118.89 482.91 113.02 483.03"
          />
          <polygon
            class="cls-37"
            points="29.82 483.03 32.79 478.08 35.69 482.91 29.82 483.03"
          />
          <polygon
            class="cls-37"
            points="28.3 474.84 33.26 477.81 28.42 480.71 28.3 474.84"
          />
          <polygon
            class="cls-37"
            points="28.3 428.49 33.26 431.46 28.42 434.36 28.3 428.49"
          />
          <polygon
            class="cls-37"
            points="28.3 381.93 33.26 384.9 28.42 387.8 28.3 381.93"
          />
          <polygon
            class="cls-37"
            points="28.3 335.29 33.26 338.26 28.42 341.16 28.3 335.29"
          />
          <polygon
            class="cls-37"
            points="28.3 289.27 33.26 292.25 28.42 295.15 28.3 289.27"
          />
          <polygon
            class="cls-37"
            points="28.3 241.83 33.26 244.81 28.42 247.7 28.3 241.83"
          />
          <polygon
            class="cls-37"
            points="28.3 195.11 33.26 198.08 28.42 200.98 28.3 195.11"
          />
          <polygon
            class="cls-37"
            points="28.3 146.78 33.26 149.75 28.42 152.65 28.3 146.78"
          />
          <polygon
            class="cls-37"
            points="527.11 163.91 522.16 160.94 526.99 158.04 527.11 163.91"
          />
          <polygon
            class="cls-37"
            points="527.11 183.56 522.16 180.59 526.99 177.69 527.11 183.56"
          />
          <polygon
            class="cls-37"
            points="527.11 203.76 522.16 200.79 526.99 197.89 527.11 203.76"
          />
        </g>
      </svg>
    </CCardBody>
  </CCard>
</template>

<script>
import store from "@/store";
import core from "@/core";
import TranspirationCalculator from "@/core/TranspirationCalculator";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "MollierDiagramComponent",
  components: {},
  mixins: [MixinsInEnvSensor()],
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          initFlag: false,
          inEnvList: [],
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      emptyFlag: true,
      updateViewType: "init",
      sensor: null,
      slider: {
        list: [],
        value: "",
      },
      default: {
        sensor: {
          dryBulbTemp: 0,
          relativeHumidity: 0,
          absoluteHumidity: 0,
          dewPointTemp: 0,
          hd: 0,
          hdColor: 0,
          vpd: 0,
          vpdColor: 0,
        },
      },
    };
  },
  created() {
    this.sensor = this.default.sensor;
    this.init();
  },
  watch: {
    "properties.initFlag"(val) {
      this.properties.initFlag = false;
      if (val) {
        this.init();
      }
    },
    "properties.inEnvList"() {
      this.redraw();
    },
    "slider.value"(val) {
      if (val != null) {
        this.redraw();
      }
    },
  },
  methods: {
    init() {
      this.sensor = this.default.sensor;

      const sliderList = [];
      const startMoment = core.date.instance(
        core.date.instance().format("YYYY-MM-DD") + "T00:00:00",
      );
      const startSec = startMoment.format("X");
      const endSec = core.date
        .instance(core.date.instance().format("YYYY-MM-DDTHH:mm") + ":00")
        .format("X");
      const length = (endSec - startSec) / 300;
      let lastDate = null;
      for (let i = 0; i < length; i++) {
        const strDate = startMoment
          .add(5, "minutes")
          .format("YYYY-MM-DD HH:mm");
        sliderList.push(strDate);
        lastDate = strDate;
      }
      this.slider.list = sliderList;
      this.slider.value = lastDate;
      // console.log(this.slider.list);
      console.log("init slider");
    },
    redraw() {
      if (this.$refs.mollierGraph == null) {
        console.log("is not ready");
        return;
      }

      const list = this.properties.inEnvList;

      let lastDate = core.date.instance();
      if (this.slider.value != null) {
        lastDate = core.date.instance(this.slider.value);
      }
      const dataList = this.getFilterDataList(list, lastDate);
      const avgList = this.getAvgDataList(dataList);

      if (dataList.length > 0) {
        this.sensor = dataList[dataList.length - 1].transpiration;
        this.emptyFlag = false;
      } else {
        this.emptyFlag = true;
      }
      this.$refs.mollierGraph.querySelectorAll("circle").forEach((node) => {
        node.remove();
      });

      const length = avgList.length;
      avgList.forEach((sensor, index) => {
        const transpiration = TranspirationCalculator.newInstance({
          dryBulbTemp: sensor.temp,
          relativeHumidity: sensor.humidity,
        });
        const circle = core.utils.image.createSvgElement("circle", {
          cx: 33.36 + 16.29 * transpiration.absoluteHumidity,
          cy: 149.21 + (35 - sensor.temp) * 9.38,
          r: 5,
          stroke: "black",
          "stroke-width": 0.1,
          fill: "rgba(" + "255" + ",0,0," + (0.9 / length) * index + ")",
        });
        this.$refs.mollierGraph.append(circle);
      });
    },
  },
};
</script>
